"use client";

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

/**
 * Radix UI (API reference): https://www.radix-ui.com/primitives/docs/components/collapsible#api-reference
 *
 * shadcn/ui docs: https://ui.shadcn.com/docs/components/collapsible
 */
const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

type CollapsibleContentProps = React.ComponentProps<typeof CollapsibleContent>;
type CollapsibleProps = React.ComponentProps<typeof Collapsible>;
type CollapsibleTriggerProps = React.ComponentProps<typeof CollapsibleTrigger>;

export {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  type CollapsibleContentProps,
  type CollapsibleProps,
  type CollapsibleTriggerProps,
};
